import { React, useState, useEffect } from "react";

const PopUpTrappResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let trapPlayer1Cards = [];
    let trapPlayer2Cards = [];
    let trapMarkets = [];
    let trapWinner = "";

    if (marketType == 56) {

        trapPlayer1Cards =
            typeof resultData?.player1Card === "string"
                ? resultData.player1Card.split(",")
                : [];

        trapPlayer2Cards =
            typeof resultData?.player2Card === "string"
                ? resultData.player2Card.split(",")
                : [];

        trapMarkets = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
        ].filter(Boolean);

        trapWinner = resultData.resultTxt || "";
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="trap" style={{ display: marketType == 56 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                {resultData.cat_rnr1}
                                            </span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "flex-start",
                                                        padding: "3px"
                                                    }}
                                                >
                                                    {trapPlayer1Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                {resultData.cat_rnr2}
                                            </span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "flex-start",
                                                        padding: "3px"
                                                    }}
                                                >
                                                    {trapPlayer2Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {trapMarkets.map((market, index) => {
                                            const winner = market === trapWinner;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    );
};

export default PopUpTrappResults;

